// extracted by mini-css-extract-plugin
export default {"loader__container":"Loader_loader__container__7QHEJ","loader__spinner":"Loader_loader__spinner__9vAIW","spin":"Loader_spin__MjPSA"};